import request from '@/utils/request'

// 예시
export function getRegulationsSampleData (params,isProgress) {
  return request({
    url: `/api/getRegulationsSampleData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 조회
export function getRegulations (params, isProgress) {
  return request({
    url: `/api/getRegulations`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 근로자 의견 조회
export function getRegulationsComment (params, isProgress) {
  return request({
    url: `/api/getRegulationsComment`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 확정문서 조회
export function getConfirmationRegulations (params, isProgress) {
  return request({
    url: `/api/getConfirmationRegulations`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

// 저장
export function saveRegulations (params, isProgress) {
  return request({
    url: `/api/saveRegulations`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' },
  })
}

// 서명 update
export function updateRegulationsSign (params) {
  return request({
    url: `/api/updateRegulationsSign`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: {apitype: 'saved' },
  })
}

// 제정/개정
export function enactRevisionRegulations (params, isProgress) {
  return request({
    url: `/api/enactRevisionRegulations`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' },
  })
}

// 삭제
export function deleteRegulations (params, isProgress) {
  return request({
    url: `/api/deleteRegulations`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' },
  })
}

export function getRegulationsReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: `/api/getRegulationsReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}
